import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=6dab17ec&scoped=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=6dab17ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dab17ec",
  null
  
)

export default component.exports